import classNames from "classnames";
import Riyal from "../ui/Riyal";
import styles from "../styles.module.scss";

interface IAmountProps {
  value?: number | null;
  /** The bold blue net amount. */
  highlighted?: boolean;
  /** The success summary's black amount. */
  dark?: boolean;
}

/** "﷼ 3,720" with the design's riyal glyph, or "-" until there is a value. */
const Amount = ({ value, highlighted, dark }: IAmountProps) => (
  <p
    dir="ltr"
    className={classNames(styles.amount, {
      [styles.amountHighlighted]: highlighted,
      [styles.amountDark]: dark,
    })}>
    {value == null ? (
      "-"
    ) : (
      <>
        <Riyal variant={highlighted ? "md" : dark ? "smDark" : "sm"} />
        {value.toLocaleString("en-US", { maximumFractionDigits: 2 })}
      </>
    )}
  </p>
);

export default Amount;
